import getConfig from "next/config";
import qs from "qs";

import { hashParamsBrandId } from "@components/shared/utils";

import { getUrlWithoutTrailingSlash } from "@shared/v2/lib/getUrlWithoutTrailingSlash";
const { getCulture } = require("@shared/v2/lib/getCulture");

const { publicRuntimeConfig } = getConfig();

const { COUNTRY } = publicRuntimeConfig;

export const getBrandIdLoginRedirect = (
  redirectUrl,
  brandIDConfig,
  language
) => {
  const locale = getCulture(language, COUNTRY);

  const {
    oAuthAuthorizeUrl,
    clientId,
    responseType,
    scope,
    dealApiUrl,
  } = brandIDConfig;

  const queryOptions = {
    addQueryPrefix: true,
    skipNulls: true,
    encode: false,
  };

  return (
    getUrlWithoutTrailingSlash(oAuthAuthorizeUrl) +
    qs.stringify(
      {
        client_id: clientId,
        response_type: responseType,
        scope,
        redirect_uri: `${getUrlWithoutTrailingSlash(
          dealApiUrl
        )}/brandid/landing-page`,
        state: hashParamsBrandId(redirectUrl),
        locale,
      },
      queryOptions
    )
  );
};
